import { gql } from '@apollo/client';
import type { ResultEvent } from '../../types/events';

export const GET_EVENT = gql`
  query getEvent($eventUniqueCode: ID!) {
    getEvent(eventUniqueCode: $eventUniqueCode)
      @rest(
        type: "EventResponse"
        path: "/v2/api/events/{args.eventUniqueCode}"
        method: "GET"
        endpoint: "bff"
      ) {
      associationUuid
      applyEventBranding
      branding
      dates
      eid
      eventUrl
      eid
      id
      listingSettings
      locale
      location
      name
      provider
      relatedEvents
      social
      styles
      subEvents
      gallery
      uniqueCode
      settings
      displayMessages
      resultsPerPage
      resultsUrl
    }
  }
`;

export type GetEventVariables = {
  eventUniqueCode: string;
};

export type GetEventData = {
  getEvent: ResultEvent;
};
